<template>
    <div
        class="border relative border-solid flex text-white items-center bg-[#090c1199] p-1 border-[#2a3546] rounded-md"
        @mouseenter="onMouseEnter"
        @mouseleave="onMouseLeave"
        :class="[containerCalss, borderColor]"
        :label="label"
    >
        <div class="flex w-full">
            <div v-if="slots.prepend" class="flex justify-center items-center">
                <slot name="prepend"></slot>
            </div>
            <span class="text-grey-40 font-semibold" v-if="label">{{ label }}</span>
            <input
                v-bind="$attrs"
                :blur="blur"
                @on-change="onChange"
                :min="min"
                :max="max"
                :readonly="readonly"
                @focus="onFocus"
                @blur="onBlur"
                :type="type"
                @input="updateModelValue"
                :placeholder="placeholder"
                :value="modelValue"
                class="placeholder-[#55657e] font-bold flex-[8] bg-transparent pl-1 flex w-[85%] outline-none"
                :class="[inputClass, 'text-white']"
                :disabled="disabled"
                :maxlength="maxlength"
            />
            <div v-if="slots.append" class="flex justify-center items-center">
                <slot name="append"></slot>
            </div>
        </div>
    </div>

    <div v-if="error" class="text-error" :class="errorStyle">{{ errorMessage }}</div>
</template>
<script setup lang="ts">
import { errorStyle } from '~/config/style';

type FocusType = 'focus' | 'error' | 'default';
const props = defineProps([
    'onChange',
    'containerCalss',
    'label',
    'inputClass',
    'modelValue',
    'type',
    'placeholder',
    'error',
    'errorMessage',
    'readonly',
    'min',
    'max',
    'blur',
    'disabled',
    'maxlength'
]);
const emit = defineEmits(['update:modelValue']);
const slots = useSlots();

const currentBorderType = ref('default') as Ref<FocusType>;

const onMouseEnter = () => {
    if (currentBorderType.value == 'error') {
        return;
    }
    currentBorderType.value = 'focus';
};

const onMouseLeave = () => {
    if (currentBorderType.value == 'error') {
        return;
    }
    currentBorderType.value = 'default';
};

const borderColor = computed(() => {
    if (currentBorderType.value == 'focus') {
        return 'border-blue';
    }
    if (props.error) {
        return 'border-error';
    }
    return 'border-[#2a3546]';
});

const updateModelValue = (e: any) => {
    const value = e.target.value;
    if (props.type == 'number') {
        if (value <= 0) {
            emit('update:modelValue', '');
        } else if (props.maxlength && value.length > props.maxlength){
            emit('update:modelValue', value.slice(0, props.maxlength));
        } else {
            emit('update:modelValue', Number(value));
        }
    } else {
        emit('update:modelValue', value);
    }
};
const onFocus = (playload) => {
    if (props.error) {
        currentBorderType.value = 'error';
    } else {
        currentBorderType.value = 'focus';
    }
};
const onBlur = (playload) => {
    if (props.error) {
        currentBorderType.value = 'error';
    } else {
        currentBorderType.value = 'default';
    }
};
if (props.error) {
    watch(props.error, (value) => {
        if (value) {
            currentBorderType.value = 'error';
        } else {
            currentBorderType.value = 'default';
        }
    });
}
</script>

<!-- ↓如果加了 scoped 下方样式将失效  -->
<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    appearance: none;
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type='number'] {
    appearance: textfield;
    -moz-appearance: textfield;
}
</style>

